import React from "react";

export default (props: React.SVGProps<SVGSVGElement>) => {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM7 11L4.3 8.3L5.2 7.5L7 9.3L11 5.4L11.9 6.2L7 11Z"
              fill="#56B465"/>
    </svg>;
}
